/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum UploadFileAliases {
  DECK_SENT = 'deck-sent',
  FETCH_SENT = 'fetch-sent',
  FIELD_FILES = 'field-files',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_SEND_FILES = 'form-send-files',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_CONTEXTUALBAR_CONTENT = 'layout-contextualbar-content',
  MY_CHART_FILE_LIST_ITEM_CARD_SENT = 'my-chart-file-list-item-card-sent',
  PANEL_FORM = 'panel-form',
  TOAST_NOTIFICATION = 'toast-notification',
  UPLOAD_FILE_CHECK_ACTION = 'upload-file-check-action',
  UPLOAD_FILE_CONTEXTUAL_BAR = 'upload-file-contextual-bar',
  UPLOAD_FILE_LAYOUT = 'upload-file-layout',
  UPLOAD_FILE_PANEL = 'upload-file-panel',
}
export { UploadFileAliases };
